import { createSelector } from "reselect"
import { initialState } from "./reducer"

/**
 * Direct selector to the profileLeader state domain
 */

const selectProfileLeaderDomain = (state) =>
  state.get("profileLeader", initialState)

/**
 * Other specific selectors
 */

export const makeSelectLoadingPlans = () =>
  createSelector(selectProfileLeaderDomain, (state) =>
    state.get("loadingPlans")
  )

export const makeSelectLeader = () =>
  createSelector(selectProfileLeaderDomain, (state) => state.get("leader"))

export const makeSelectTeamLeader = () =>
  createSelector(selectProfileLeaderDomain, (state) => state.get("team_leader"))

export const makeSelectLoadingPhoto = () =>
  createSelector(selectProfileLeaderDomain, (state) =>
    state.get("loadingPhoto")
  )

/**
 * Default selector used by ProfileLeader
 */

const makeSelectProfileLeader = () =>
  createSelector(selectProfileLeaderDomain, (substate) => substate.toJS())

export default makeSelectProfileLeader
export { selectProfileLeaderDomain }
